import { type FC } from 'react';
import { Trans } from 'react-i18next';
import ClockIcon from '@assets/img/icons/clock.svg?react';
import FlagIcon from '@assets/img/icons/flag.svg?react';
import InfoIcon from '@assets/img/icons/info.svg?react';
import WarningIcon from '@assets/img/icons/warning.svg?react';
import cn from 'classnames';

import { TextXSmall } from '@/components/Typography/Typography';

import { type PromoErrors } from '../PromoCodeForm/config';

interface PromoNotificationProps {
  error?: PromoErrors | 'DEFAULT';
}

const PromoNotification: FC<PromoNotificationProps> = ({ error }) => {
  const iconClassName = 'w-6 h-6 shirnk-0 text-inherit';

  const errorText: Record<PromoErrors | 'DEFAULT', string> = {
    USED_ALREADY:
      'This promo code has already been used <br /> and cannot be activated again',
    EXPIRED: 'This promo code has expired <br /> and can no longer be used',
    LIMIT_REACHED:
      'All rewards for this promo code have <br /> already been claimed by other players',
    INVALID: 'Invalid promo code',
    DEFAULT: 'Something went wrong, please try again',
  };

  const text = error
    ? errorText[error]
    : 'Promo codes may be one-time use <br /> or have a limited validity period';

  return (
    <div
      className={cn(
        'w-full py-1 px-2 rounded-lg border border-white/20 flex items-center gap-2 mb-4 text-white/60',
        error && '!text-red !border-red',
      )}
    >
      {error ? (
        <>
          {error === 'LIMIT_REACHED' && <FlagIcon className={iconClassName} />}
          {(error === 'USED_ALREADY' ||
            error === 'INVALID' ||
            error === 'DEFAULT') && <WarningIcon className={iconClassName} />}
          {error === 'EXPIRED' && <ClockIcon className={iconClassName} />}
        </>
      ) : (
        <InfoIcon className={iconClassName} />
      )}
      <TextXSmall className="!text-inherit !italic">
        <Trans i18nKey={text} components={{ br: <br /> }} />
      </TextXSmall>
    </div>
  );
};

export { PromoNotification };
